import { render } from "./SmsPage.vue?vue&type=template&id=0ca21be7&scoped=true"
import script from "./SmsPage.vue?vue&type=script&lang=js"
export * from "./SmsPage.vue?vue&type=script&lang=js"

import "./SmsPage.vue?vue&type=style&index=0&id=0ca21be7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca21be7"]])

export default __exports__